<template>
<div class="full-page-width">
  <div class="unapproved relative">
    <div class="add-button c-float m-b-20 flex is-flex-wrap">
      <div class="flex" style="flex-grow: 1">
        <p class="user-name">{{ $t('Waiting for approval') }}</p>
      </div>
      <Dropdown
        class="flex drop-right"
        :buttonText="$t('add')"
        :dropdownOptions="dropdownOptions"
        @optionSelected="optionSelected" />
    </div>
    <DataTable
      :dropdown=false
      :tableHeader=true
      :tableHead=true
      tableAPI="UNAPPROVED_SHIPMENTS"
      tableActions="UNAPPROVED_SHIPMENTS"
      :actionsOptions="actionsOptions"
      :totalCount="totalCount"
      :checkbox=true
      :type="type"
      :count="get_unapproved_count"
      :list="get_unapproved_list"
      :rowActionParameter="rowActionParameter"
      :referenceData="referenceData"
      :filterOptions="filterOptions"
      :customTable=false
      :updateIterator="updateIterator"
      @updatedSelections="tableSelectionsUpdated"
      @actionOptionTriggered="actionOptionTriggered"
      @rowAction="rowAction" />
  </div>
  <Popup
    v-if="openImport"
    :showConfirmButton="showImportButton && !get_error_message"
    :confirmText="$t('import')"
    @cancel="togglePopupEdit"
    @confirm="submitForm">
    <template v-slot:header>
      <h2>{{ $t('Import Template') }}</h2>
    </template>
    <UploadTemplate
      @enabeImport="enableImport"
      @disableImport="showImportButton = false"
      @closePopup="closePopupAndTrackImportProcess"
      @uploaded="updateTableAfterUpload"
      templateType="shipment_fields" />
      <message
        v-if="get_error_message.type"
        name="warning"
        :data="get_error_message" />
  </Popup>
  <a
    style="display: none"
    :download="`Unapproved.csv`"
    ref="exportData"
    :href="exportDataPath" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import DataTable from '@/components/table/index.vue';
import Popup from '@/components/global/popup';
import Dropdown from '@/components/global/dropdown';
import UploadTemplate from '@/components/global/uploadTemplate';
import EventBus from '@/eventBus.js';

/* eslint-disable */
export default {
  name: 'UnapprovedShipments',
  components: { DataTable, Btn, Popup, UploadTemplate, Dropdown },
  data() {
    return {
      updateIterator: 1,
      isTableAllSelected: false,
      totalCount: 300,
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('View unapproved')}`,
      },
      type: {
        type: true,
        data: 'status', // generate_invoice_spec_file_type
        text: `${this.$t('status')}`,
        icons: {
          38: 'checkMan',// unapproved
        },
      },
      referenceData: [
        {
          created_at: `${this.$t('created_at')}`,
          creator_user_name: `${this.$t('created_by')}`,
        },
        {
          customer_name: `${this.$t('receiver')}`,
          customer_address_country_name: `${this.$t('country')}`,
        },
        {
          sender_reference: `${this.$t('Sender ref.:')}`,
          create_type: `${this.$t('Source')}`,
        },
      ],
      dropdownOptions: [
        {
          text: `${this.$t('Create Shipment')}`,
          subText: `${this.$t('Type in manually')}`,
          icon: 'plus',
        },
        {
          text: `${this.$t('upload_shipments')}`,
          subText: `${this.$t('Bulk import from file')}`,
          icon: 'cloudUpload',
        },
      ],
      actionsOptions: [
        {
          text: `${this.$t('Delete')}`,
          subText: `${this.$t('Delete selections')}`,
          icon: 'deleteForever',
        },
        {
          text: `${this.$t('print')}`,
          subText: `${this.$t('print')}`,
          icon: 'printer',
        },
        {
          text: `${this.$t('Export data')}`,
          subText: `${this.$t('Export data')}`,
          icon: 'cloudUpload',
        },
      ],
      openImport: false,
      showImportButton: false,
      exportDataPath: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_error_message',
      'get_unapproved_list',
      'get_unapproved_count',
      'get_filters_menu',
      'get_active_filter',
      'get_all_shipments_query',
      'get_import_queue',
    ]),
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'unapproved',
        tableApi: 'shipment/get-unapproved-shipments-list',
        filterFields: {
          create_type: {
            label: `${this.$t('Source')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('App')}`, value: 'app'},
              {text: `${this.$t('upload_template')}`, value: 'upload'},
              {text: 'Api', value: 'api'}
            ],
          },
          status: {
            label: `${this.$t('status')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('ready')}`, value: '1'},
              {text: `${this.$t('error')}`, value: '8'},
              {text: `${this.$t('processing')}`, value: '17'},
              {text: `${this.$t('Carrier Error')}`, value: '36'}
            ],
          },
          ship_date: {
            label: `${this.$t('ship_date')}`,
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          created_at: {
            label: `${this.$t('created_at')}`,
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          subaccount_id: {
            label: `${this.$t('account')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          custom_tags: {
            label: `${this.$t('Tags')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_agent_name: {
            label: `${this.$t('shipping_agent_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_product_name: {
            label: `${this.$t('Product name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          weight: {
            label: `${this.$t('weight')}`,
            type: 'options',
            value: {
              value: '',
              additional: '',
            },
          },
          goods_type: {
            label: `${this.$t('goods_type')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('parcel')}`, value: '1'},
              {text: `${this.$t('document')}`, value: '2'},
              {text: `${this.$t('pallet')}`, value: '3'},
              {text: `${this.$t('load')}`, value: '4'},
            ],
          },
          receiver_reference: {
            label: `${this.$t('reciever_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_company_name: {
            label: `${this.$t('receiver_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_name: {
            label: `${this.$t('receiver_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_address: {
            label: `${this.$t('receiver_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_post_code: {
            label: `${this.$t('receiver_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_country_id: {
            label: `${this.$t('receiver_country_id')}`,
            type: 'country',
            value: {
              value: [],
              additional: '',
            },
          },
          sender_reference: {
            label: `${this.$t('sender_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_company_name: {
            label: `${this.$t('sender_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_name: {
            label: `${this.$t('sender_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_address: {
            label: `${this.$t('sender_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_post_code: {
            label: `${this.$t('sender_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_country_id: {
            label: `${this.$t('sender_country_id')}`,
            type: 'country',
            value: {
              value: [],
              additional: '',
            },
          },
          goods_incoterm: {
            label: `${this.$t('goods_incoterm')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: 'DAP', value: 'DAP'},
              {text: 'DDP', value: 'DDP'},
              {text: 'EXW', value: 'EXW'},
              {text: 'FCA', value: 'FCA'},
              {text: 'CPT', value: 'CPT'},
              {text: 'CIP', value: 'CIP'},
              {text: 'DPU', value: 'DPU'},
              {text: 'FAS', value: 'FAS'},
              {text: 'FOB', value: 'FOB'},
              {text: 'CFR', value: 'CFR'},
              {text: 'CIF', value: 'CIF'},
            ],
          },
          duty_paid_by: {
            label: `${this.$t('duty_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('duty_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Reciever').toLowerCase()}`, value: '2'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Third party').toLowerCase()}`, value: '3'},
            ],
          },
          freight_paid_by: {
            label: `${this.$t('freight_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('freight_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('freight_paid_by')} ${this.$t('Other').toLowerCase()}`, value: '2'},
            ],
          },
        },
      }
    },
  },
  methods: {
    updateTableAfterUpload() {
      this.updateIterator++;
    },
    tableSelectionsUpdated(val) {
      this.isTableAllSelected = val.selectTotalRows;
    },
    rowAction(val) {
      let shipmentId = this.get_unapproved_list.filter((item) => item.id == val)[0].id;
      this.$store.dispatch('GET_SINGLE_UNAPPROVED', shipmentId).then((res) => {
        this.$store.dispatch('SET_EDITING_SHIPMENT', {
          shipmentType: 'unapproved',
          ...res,
        }).then(() => {
          this.$router.push('book-shipment');
        });
      });
    },
    actionOptionTriggered(option) {
      if(option.dropOption == 'dropOption1') {
        // Delete
        if(this.isTableAllSelected){
          this.$store.dispatch('DELETE_UNAPPROVEDS', {
            type: 'byFilter',
            search: this.$route.query.search,
            searchTerm: this.$route.query.searchTerm,
            count: this.get_unapproved_count,
          }).then(() => {
            this.updateIterator++;
          })
        } else {
          this.$store.dispatch('DELETE_UNAPPROVEDS', {
            type: 'byId',
            id: 0,
            ids: option.list,
          }).then(() => {
            this.updateIterator++;
          });
        }
      }
      if(option.dropOption == 'dropOption2') {
        // Print
        let payloadObject;
        if(this.isTableAllSelected){
          payloadObject = {
            shipment_ids: null,
            search: this.$route.query.search,
            searchTerm: this.$route.query.searchTerm,
            count: this.get_unapproved_count,
          }
        } else {
          payloadObject = {
            shipment_ids: option.list,
            search: null,
            searchTerm: null,
            count: null,
          }
        }
        this.$store.dispatch('PRINT_UNAPPROVEDS', payloadObject).then((res) => {
          this.updateIterator++;
          if(res.failed.length > 0 ) {
            let message = '';
            for (const property in res.messages) {
              message += `Shipment${property}:</br> ${res.messages[property]}</br>`;
            }
            this.$store.commit('SHOW_NOTIFICATION_BAR', {
              message: message,
              type: 'alert-window',
              iconName: 'warningSign',
            });
            return;
          }
          if(res.processed.length > 0){
            this.trackProgressValidation(res).then(() => {});
            this.updateIterator++;
          }
        });
      }
      if(option.dropOption == 'dropOption3') {
        // Export
        if(this.isTableAllSelected){
          this.$store.dispatch('EXPORT_CSV', {
            query: this.get_all_shipments_query?'&'+this.get_all_shipments_query.substring(1):'',
            tableName: 'unapproved-shipments',
            ids: [],
          }).then((res) => {
            this.$nextTick(() => {
              const blob = new Blob([res], {type: "octet/stream"});
              const url = window.URL.createObjectURL(blob);
              this.$refs.exportData.href = url;
              // this.$refs.exportData.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(res);
              this.$refs.exportData.click();
              window.URL.revokeObjectURL(url);
            })
          });
        } else {
          this.$store.dispatch('EXPORT_CSV', {
            tableName: 'unapproved-shipments',
            ids: option.list,
          }).then((res) => {
            this.$nextTick(() => {
              const blob = new Blob([res], {type: "octet/stream"});
              const url = window.URL.createObjectURL(blob);
              this.$refs.exportData.href = url;
              // this.$refs.exportData.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(res);
              this.$refs.exportData.click();
              window.URL.revokeObjectURL(url);
            })
          });
        }
      }
    },
    trackProgressValidation(id) {
      let idOfProgress = id;
      return new Promise((resolve, reject) => {
        this.$store.dispatch('TRACK_VALIDATION_PROGRESS', idOfProgress)
        .then((res) => {
          let response = res.data.data;
            if(response !== 'progress-done'){
              this.$store.commit('STORE_UPLOAD_PROGRESS', response);
              const self = this;
              setTimeout(() => {
                this.trackProgressValidation(idOfProgress);
              }, 2000);
            } else {
              this.$store.commit('STORE_UPLOAD_PROGRESS', 100);
              this.updateIterator++;
              resolve(idOfProgress);
            }
        });
      });
    },
    navigateToCreateShipment() {
      this.$router.push('book-shipment');
    },
    optionSelected(opt) {
      if(opt === 'dropOption1') {
        this.createNewShipment();
      }
      if(opt === 'dropOption2') {
        this.openImportTemplatePopup();
      }
    },
    createNewShipment() {
      this.$router.push('/shipments/book-shipment');
    },
    openImportTemplatePopup() {
      this.openImport = true;
      this.$store.dispatch('GET_TEMPLATES');
    },
    togglePopupEdit() {
      this.openImport = !this.openImport;
    },
    submitForm() {
      EventBus.$emit('import_template');
    },
    enableImport() {
      this.showImportButton = true;
    },
    closePopupAndTrackImportProcess() {
      this.togglePopupEdit();
    },
  },
  watch: {
    get_import_queue: {
      handler(newValue) {
        newValue.forEach(queObj => {
          if(queObj.templateType == 'shipment_fields' && queObj.progressStatus == 100) {
            this.updateIterator++;
          }
        })

      },
      deep: true
    }
  }
};
</script>
